import React, {useRef, useState} from 'react';
import {
    Box, Typography, Button, Paper, TextField, IconButton,
    RadioGroup, Radio, FormControlLabel, Checkbox, Grid, Stack, Container, Alert
} from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {DialogsProvider, useDialogs} from '@toolpad/core/useDialogs';
import bottle1 from './images/bottle1.png';
import bottle2 from './images/bottle2.png';
import bottle3 from './images/bottle3.png';
import bottle4 from './images/bottle4.png';
import bottle5 from './images/bottle5.png';
import bottle6 from './images/bottle6.png';
import bottle7 from './images/bottle7.png';
import bottle8 from './images/bottle8.png';
import bottle9 from './images/bottle9.png';
import bottle10 from './images/bottle10.png';

const staticPlayers = [
    {id: 1, name: 'Player 1'},
    {id: 2, name: 'Player 2'},
]
function _App() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedBottle, setSelectedBottle] = useState(0);
    const [players, setPlayers] = useState([...staticPlayers]);
    const [isSpinning, setIsSpinning] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const bottleRef = useRef(null);
    const [adjAngle, setAdjAngle] = useState((360 / players.length) / 2);
    const [eliminationMode, setEliminationMode] = useState(false);
    const [message, setMessage] = useState("");
    const [speed, setSpeed] = useState(6000);
    const [debug, setDebug] = useState(true);
    const playerRef = useRef(null);
    const circleRef = useRef(null);
    const [playerTempName, setPlayerTempName] = useState("")
    const dialogs = useDialogs();
    const [eliminatedPlayers, setEliminatedPlayers] = useState([])

    const updatePlayerName = (id, newName) => {
        setPlayers(prev =>
            prev.map(player => player.id === id ? { ...player, name: newName } : player)
        );
    };

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const addPlayer = () => {
        const id = players.length + eliminatedPlayers.length + 1;
        setPlayers((prev) => {
            return  [...prev, {id, name: `Player ${id}`}]
        });
        setTimeout(() => {
            const el = playerRef.current;
            if (el) {
                el.scrollTop = el.scrollHeight;
            }
        }, 100)
    };

    const calculateSelectedPlayer = (rotation) => {
        const perPlayerArea = 360 / players.length;
        const currentRotation = rotation % 360;
        players.forEach((player, i) => {
            const angleStart = (perPlayerArea * i);
            const angleEnd = (perPlayerArea * i) + (perPlayerArea);
            if(currentRotation > angleStart && currentRotation <= angleEnd){
                setSelectedPlayer(players[i]);
                if(eliminationMode){
                    console.log(i)
                    eliminatePlayer(i)
                }
            }
        });
    };

    const spinBottle = () => {
        if (isSpinning) return;
        setIsSpinning(true);
        setSelectedPlayer(null);

        const randomSpins = Math.floor(Math.random() * 5) + 5; // 5-9 spins
        const finalAngle = Math.random() * 360;
        const totalRotation = (randomSpins * 360) + finalAngle;

        let start = null;
        const duration = speed; // 6 seconds

        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            const easedProgress = Math.min(progress / duration, 1);
            const currentRotation = totalRotation * easeOutCubic(easedProgress);
            setAdjAngle(currentRotation);

            if (progress < duration) {
                requestAnimationFrame(animate);
            } else {
                setIsSpinning(false);
                calculateSelectedPlayer(currentRotation);
            }
        };

        requestAnimationFrame(animate);
    };

    const renderPlayersAroundCircle = () => {

        const half = (circleRef.current?.offsetWidth || (isMobile ? 300 : 400)) / 2
        const radius = ((half / 100) * 20) + half;
        const centerX = half || 200;
        const centerY = half || 200;
        const angleStep = 360 / players.length;

        return players.map((player, index) => {
            const angle = (angleStep * index) + (angleStep / 2);
            const x = centerX + radius * Math.cos(angle * (Math.PI / 180));
            const y = centerY + radius * Math.sin(angle * (Math.PI / 180));

            const textRotation = (angle > 90 && angle < 270)

            return (
                <div
                    key={player.id}
                    className={`player-dot ${selectedPlayer?.id === player.id ? 'selected' : ''}`}
                    style={{
                        position: 'absolute',
                        left: `${x}px`,
                        top: `${y}px`,
                        transform: `translate(-50%, -50%) rotate(${angle}deg)`
                    }}
                >
                    <Typography sx={{transform: `scale(${textRotation ? -1 : 1})`}}>
                        {player.name}
                    </Typography>
                </div>
            );
        });
    };

    const renderDivisionLines = () => {
        const angleStep = 360 / players.length;
        return players.map((player, index) => {
            const playerAreaStart = (angleStep * index);
            return (
                <div
                    key={`line-${player.id}`}
                    className="division-line"
                    style={{
                        transform: `rotate(${playerAreaStart}deg)`,
                        transformOrigin: 'left',
                    }}
                >
                    {/*{<span className="deg">{playerAreaStart.toFixed(2)}</span>}*/}
                </div>
            );
        });
    };

    const eliminatePlayer = (playerIndex) => {
        const _players = players
        const elimP = [...eliminatedPlayers]
        elimP.push(players[playerIndex])
        setEliminatedPlayers(elimP)
        console.log({eliminatedPlayers, players})
        setMessage(`${players[playerIndex].name} Eliminated!`)
        setTimeout(() => {
            setMessage("")
        }, 3000)
        _players.splice(playerIndex, 1)
        setPlayers(_players);
    }

    const resetGame = async () => {
        const confirm = await dialogs.confirm(`Are you sure you want to reset?`);
        if (confirm) {
            setSelectedBottle(0)
            setPlayers([...staticPlayers])
            setAdjAngle((360 / 2 / 2));
            setMessage("")
            setSpeed(6000)
            setEliminationMode(false)
            setSelectedPlayer(null);
            setEliminatedPlayers([])
        }
        setTimeout(() => {
            console.log(players, [...staticPlayers])
        }, 500)
    }

    const bottleImages = [bottle1, bottle2, bottle3, bottle4, bottle5, bottle6,
        bottle7,
        bottle8,
        bottle9,
        bottle10];

    const infoBox = (
        <Box mt={4}>
            <Typography variant="h5">How to Play Spin the Bottle</Typography>
            <Typography sx={{mb: 1}}>SpinTheBottleParty brings the classic party game online! Follow these simple steps:</Typography>
            <ol>
                <li>Choose your favorite bottle design from our collection of 10 unique bottles</li>
                <li>Enter the names of all players (between 2-20 players)</li>
                <li>Select your preferred spinning speed</li>
                <li>Click the <strong>"SPIN THE BOTTLE"</strong> button and watch it spin!</li>
                <li>The bottle will randomly point to one player when it stops</li>
            </ol>
        </Box>
    )

    const ElimPlayersList = () => (
        <Paper sx={{p: 2, mb: 3, position: "absolute",
            top: "70px",
            right: "15px",
            borderRadius: {md: "5px !important"}}}>
            <Typography variant="h5" gutterBottom sx={{mb: 2}}>Eliminated Players</Typography>
            {eliminatedPlayers?.length && eliminatedPlayers.map((p, i) => (
                <Grid item size={{xs: 6, sm: 6, md: 12}} key={i} display="flex" alignItems="center">
                    <Typography>{p.name}</Typography>
                </Grid>
            ))}
        </Paper>
    )

    return (
        <div>
            {message ? (
                <Alert sx={{position: "absolute", top: "15px", right: "15px", zIndex: 1}} severity="warning" onClose={() => {setMessage("")}}>
                    {message}
                </Alert>
            ) : null}
            <Container maxWidth="lg" sx={{pt: "70px"}}>
                {/* Ad Placeholder */}
                <Box sx={{p: 5, mb: 3, background: "#f7f7f7", textAlign: 'center', minHeight: "150px", border: "1px solid #DDD"}}>Ad Here</Box>

                {/* Title */}
                <Typography sx={{fontSize: "6rem", color: "white"}} variant="h1" align="center" fontWeight="bold">
                    SpinTheBottleParty
                </Typography>
                <Typography variant="h2" align="center" className="tagline" sx={{mb: 3, color: "#f66b4a"}}>
                    The Ultimate Spin the Bottle Game
                </Typography>

                {/* Bottle & Players Circle */}
                <Box sx={{display: 'flex', justifyContent: 'center', mb: 3, position: "relative"}}>
                    <div className="circle-container">
                        <div className="circle" ref={circleRef}>
                            {renderDivisionLines()}
                            {renderPlayersAroundCircle()}
                            <div className="blur-circle">&nbsp;</div>
                            <div
                                className="bottle"
                                ref={bottleRef}
                                style={{
                                    transform: `translate(-50%, -50%) rotate(${adjAngle}deg)`,
                                    display: 'flex',
                                    flexDirection: 'column-reverse'
                                }}
                            >
                                {debug ?? <div className="deg" style={{fontSize: "15px", display: "block", width: "100%", left: "-12px", top: "-8px"}}>{((adjAngle) % 360).toFixed(2)}</div>}
                                <div style={{transform: 'rotate(90deg)', lineHeight: 0, zIndex: 0, fontSize: "90px"}}>
                                    <img src={bottleImages[selectedBottle]} alt="Hero Party Spin Bottle" style={{maxWidth: "50px", minHeight: "150px"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {eliminatedPlayers?.length ? <Box sx={{display: {xs: "none", lg: "block"}}}>
                        <ElimPlayersList />
                    </Box> : null}
                </Box>

                {/* Spin Button */}
                <Box sx={{textAlign: 'center', mb: 3, display: "flex",
                    flexDirection: "column",
                    alignItems: "center"}}>
                    <Button variant="contained" size="large" className="spin-bottle colored" onClick={spinBottle}
                            disabled={isSpinning || players.length === 1}>
                        {isSpinning ? 'SPINNING...' : 'SPIN THE BOTTLE'}
                    </Button>
                    <Button onClick={resetGame} disabled={isSpinning} variant="outlined" className="reset-rounded" sx={{
                        borderColor: "#EF7C61 !important", color: "#EF7C61 !important",
                        borderRadius: "100px", m: 1, textAlign: "center", "& span": {m: 0},
                        transition: "all 0.5s ease-in-out",
                        minWidth: "40px !important",
                        p: 2.5,
                        "& span#test": {
                            // width: "0 !important",
                            // overflow: "hidden",
                            // transition: "width 0.5s ease",
                        },
                        "&:hover span#test": {
                            // width: "50px !important",
                        }
                    }} startIcon={<RotateLeftIcon sx={{m: "auto"}} />}><span id="test">Reset</span></Button>
                </Box>

                {/* Choose Your Bottle */}
                <Paper sx={{p: 2, mb: 3}}>
                    <Typography variant="h5" gutterBottom sx={{mb: 2}}>Choose Your Bottle</Typography>
                    <Grid container spacing={1} className="bottle-container scrollable">
                        {bottleImages.map((src, index) => (
                            <Grid item key={index} className={`bottle-item ${selectedBottle === index ? "selected" : ""}`} onClick={() => setSelectedBottle(index)}
                            >
                                <Box
                                    sx={{}}
                                    component="img"
                                    src={src}
                                    alt={`Party bottle ${index+1}`}
                                    maxWidth={"100%"}
                                    maxHeight={"100%"}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Paper>

                {/* Speed + Options + Players */}
                <Grid container spacing={2} sx={{flexDirection: {sm: 'column-reverse', md: 'row'}}}>
                    <Grid item size={{lg: 9, md: 8, xs: 12}}>
                        <Paper sx={{p: 2, mb: 2}}>
                            <Typography variant="h5" gutterBottom>Spinning Speed</Typography>
                            <RadioGroup
                                value={speed}
                                onChange={(e) => setSpeed(e.target.value)}
                                sx={{display: 'flex', flexDirection: 'row'}}
                            >
                                <FormControlLabel value={9000} onChange={({target}) => {setSpeed(parseInt(target.value))}} control={<Radio/>} label="Slow"/>
                                <FormControlLabel value={6000} onChange={({target}) => {setSpeed(parseInt(target.value))}} control={<Radio/>} label="Medium"/>
                                <FormControlLabel value={3000} onChange={({target}) => {setSpeed(parseInt(target.value))}} control={<Radio/>} label="Fast"/>
                            </RadioGroup>
                        </Paper>
                        <Paper sx={{p: 2}}>
                            <Typography variant="h5" gutterBottom>Game Options</Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={eliminationMode}
                                        onChange={(e) => setEliminationMode(e.target.checked)}
                                    />
                                }
                                label="Elimination Mode"
                            />
                            <Box sx={{display: "flex", alignItems: "flex-start", color: "#666", "& p": {fontSize: "0.9em"}}}>
                                <InfoOutlineIcon sx={{mr: "5px"}} />
                                <Typography>After each spin, the selected player is removed from the game. Spins continue until only one player remains — the ultimate survivor!</Typography></Box>
                        </Paper>
                        <Box sx={{display: {md: "block", xs: "none"}}}>{infoBox}</Box>
                    </Grid>
                    <Grid item size={{lg: 3, md: 4, xs: 12}}>
                        <Paper sx={{p: 2}}>
                            <Typography variant="h5" gutterBottom>Players <small>({players.length})</small></Typography>
                            <Box>
                                <Grid container spacing={1} id="players" ref={playerRef} sx={{maxHeight: "200px", overflow: "auto"}} className="scrollable">
                                    {players?.map((p, i) => (
                                        <Grid item size={{xs: 6, sm: 6, md: 12}} key={i} display="flex" alignItems="center">
                                            <TextField
                                                onFocus={(e) => {
                                                    if(p.name.includes("Player ")) {
                                                        setPlayerTempName(p.name);
                                                        e.target.value = "";
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    if(p.name.includes("Player ")) {
                                                        setPlayerTempName(p.name);
                                                        e.target.value = "";
                                                    }
                                                }}
                                                placeholder={`Player ${i+1}`}
                                                sx={{mb: 1}}
                                                value={p.name}
                                                onChange={(e) => {
                                                    updatePlayerName(p.id, e.target.value)
                                                    setPlayerTempName("")
                                                }}
                                                size="small"
                                                fullWidth
                                            />
                                            <IconButton disabled={players.length < 3} onClick={() => setPlayers(players.filter((_, idx) => idx !== i))}>
                                                <CloseIcon fontSize="small"/>
                                            </IconButton>
                                        </Grid>
                                    ))}
                                </Grid>
                                {eliminatedPlayers.length ?
                                    <Box sx={{mt: 3, display: {xs: "block", lg: "none"}}}>
                                    <Typography variant="h6" gutterBottom sx={{mb: 2}}>Eliminated Players</Typography>
                                    {eliminatedPlayers.length && eliminatedPlayers.map((p, i) => (
                                        <Grid item size={{xs: 6, sm: 6, md: 12}} key={i} display="flex" alignItems="center">
                                            <Typography>{p.name}</Typography>
                                        </Grid>
                                    ))}
                                    </Box> :
                                    null}
                                <Button
                                    disabled={players.length === 20}
                                    variant="contained"
                                    className="colored" sx={{mt: 3}}
                                    onClick={addPlayer}
                                >
                                    Add Player
                                </Button>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{display: {md: "none", xs: "block"}}}>
                    {infoBox}
                </Box>
                <Box sx={{mb: 5}} />

                <Box sx={{p: 5, mb: 3, background: "#f7f7f7", textAlign: 'center', minHeight: "150px", border: "1px solid #DDD"}}>Ad Here</Box>
            </Container>
        </div>
    );
}
export default function App() {
    return (
    <DialogsProvider>
        <_App />
    </DialogsProvider>
)}